import tech from "../../../assets/Services_img/techSupport.jpg";

export const customizationUpgradeSupportService = {
  hero: {
    title: "Customization, Upgrades & Technical ",
    description:
      "Flexible engineering solutions and long-term technical support for evolving glovebox applications.",
      title2:"Support",
      imgUrl:tech
  },

  productsDetails: {
    imgList: [
      tech
    ],

    productName: "Customization, Upgrades & Technical Support",

    description:
      "ProRes provides comprehensive customization, system upgrades, and technical support services to adapt glovebox systems to changing research and production requirements. From design modifications and modular expansions to automation integration and spare parts supply, our engineering team ensures long-term system reliability and performance.",

    keyFeatures: [
      "Custom glovebox design modifications",
      "System expansions and modular upgrades",
      "Automation and robotic integration",
      "Retrofit solutions for existing installations",
      "OEM-compatible spare parts and accessories",
      "Dedicated after-sales and technical support",
    ],

    download: {
      title: "Download Service Overview PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Service Description",

    briefDescirption:
      "As applications evolve, glovebox systems must adapt without compromising performance or safety. ProRes customization and upgrade services extend system capability, improve efficiency, and provide dependable technical support throughout the system lifecycle.",
  },
};
